module.exports = __webpack_public_path__ + "c65260dd3da944cda68352fc588fa293.svg";